import { FieldTypes, getOldFields, OldFields } from './content';
import { InlineValue } from './InlineValue';

interface DeltaInsertOp {
  insert: any;
  attributes: any;
}

interface IDataContext {
  [key: string]: string | number;
}

export class InlineReference extends InlineValue {
  static create = (deltaOp: DeltaInsertOp) => {
    return new InlineReference(deltaOp);
  };

  public resolveFieldsReference = (dataContext: IDataContext, fallbackStr: string = 'No data available', content: any) => {
    const options = this.deltaOp.insert.value;
    const { fieldType } = options as { fieldType: keyof OldFields };
    const oldFields = getOldFields(content.type, content?.typeSpecific?.dimensions);
    this.fieldName = oldFields[fieldType];

    return this.resolveFields(dataContext, fallbackStr);
  };
}
